import { z } from 'zod';
import { registry } from '../registry';
import { neurosensoryCardTitles } from './neurological';
const wnlMessage = { message: 'Mark as within normal limits if none applies', path: [] };
export const basePsychosocialSchema = z
    .object({
    wnl: z.boolean().optional().register(registry, { label: 'WNL' }),
    status: z
        .array(z.string())
        .optional()
        .register(registry, {
        label: 'Psychosocial status',
        options: [
            { value: 'Adequate family, PCG or in-home support', label: 'Adequate family/PCG support' },
            { value: 'Agitated', label: 'Agitated' },
            { value: 'Anxious', label: 'Anxious' },
            { value: 'Cooperative', label: 'Cooperative' },
            { value: 'Coping', label: 'Coping' },
            { value: 'Depressed', label: 'Depressed' },
            { value: 'Discouraged', label: 'Discouraged' },
            { value: 'Flat affect', label: 'Flat affect' },
            { value: 'Inappropriate response', label: 'Inappropriate response' },
            { value: 'Socially isolated', label: 'Socially isolated' },
            { value: 'Caregiver stress / burden', label: 'Caregiver stress / burden' },
            { value: 'Refuses / Resists care', label: 'Refuses / Resists care' },
            { value: 'Substance use concern', label: 'Substance use concern' },
            { value: 'Sleep disturbance', label: 'Sleep disturbance' },
            { value: 'Suicidal ideation / Self-harm', label: 'Suicidal ideation / Self-harm' },
        ],
    }),
})
    .register(registry, { label: neurosensoryCardTitles.psychosocial });
export const basePsychosocialSchemaRefined = basePsychosocialSchema.refine((data) => data.wnl || data.status?.length, wnlMessage);
